import React from 'react';
import { Loader } from 'freemium-ui';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

const MFELoader = ({ wcLoading = false }: { wcLoading?: boolean }) => {
  return (
    <StyledPageLoader className={wcLoading ? 'wc-loading' : ''}>
      <HeaderSkeleton />
      <div className="content">
        <Loader />
      </div>
    </StyledPageLoader>
  );
};

const HeaderSkeleton = () => {
  return (
    <div className="top-nav">
      <div className="action-bar">
        <div className="steps">
          <Skeleton height={25} width={100} />
          <Skeleton height={25} width={100} />
        </div>
        <div className="actions">
          <Skeleton height={25} width={80} />
          <Skeleton height={25} width={65} />
          <Skeleton height={25} width={65} />
        </div>
      </div>
    </div>
  );
};

const StyledPageLoader = styled.div`
  height: 100%;
  .top-nav {
    background-color: #f5f7f9;
    border-bottom: 1px #cfd7df solid;
    padding: 0 15px;
    box-shadow: 0 2px 4px 0 rgba(18, 52, 77, 0.08);
    height: 56px;

    .action-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 15px 10px 10px;

      .actions,
      .steps {
        display: flex;
        align-items: center;
        gap: 20px;
      }
    }
  }

  .content {
    display: grid;
    place-items: center;
    height: calc(100% - 56px);

    & > div {
      border: 4px solid var(--color-azure-800);
      border-top: 4px solid #ffffff;
      width: 24px;
      height: 24px;
    }
  }

  &.wc-loading {
    height: calc(100vh - 65px);
  }
`;

export default MFELoader;
